import { z } from 'zod';
import { BaseElementSchema } from '@/components/canvas/document/schema/elementBase';

export const ChartElementSchema = BaseElementSchema.extend({
  type: z.literal('chart'),
  data: z.object({
    chartType: z.enum(['bar', 'line', 'pie']),
    spec: z.unknown(),
  }),
});
